<template>
  <div class="data-input">
    <n-header/>
    <div class="data-input-header">
      <div class="data-input-header__wrapper">
        <nav class="tab-menu">
          <a
            class="tab-button"
            :class="isCropAndSoilSelected ? 'selected' : ''"
            @click.prevent="handleTabCropSoilClick">
            {{$t('ui.crop-and-soil')}}
          </a>
          <a
            class="tab-button"
            :disabled="region === null || soil === null || crop === null"
            :class="isFertilizerManagementSelected ? 'selected' : ''"
            @click.prevent="handleTabFertilizerClick">
            {{$t('ui.fertilizer-management')}}
          </a>
          <a
            class="tab-button"
            :disabled="region === null || soil === null || crop === null"
            :class="isIrrigationManagementSelected ? 'selected' : ''"
            @click.prevent="handleTabIrrigationClick">
            {{$t('ui.irrigation-management')}}
          </a>
        </nav>
        <button
          type="submit"
          class="button--submit"
          :disabled="region === null || soil === null || crop === null"
          @click="handleRunSimulationClick">
          {{$t('ui.run-simulation')}}
        </button>
      </div>
    </div>
    <div class="form" v-if="isCropAndSoilSelected">
      <section>
        <h3>{{$t('location')}}</h3>
        <n-input-select
          :label="$t('location')"
          :options="regions"
          :value="regionId"
          @change="handleRegionChange" />
        <n-input-number
            :label="$t('Latitude')"
            :value="Latitude"
            :disabled="region === null"
            @change="handleLatitudeChange" />
        <n-input-number
            :label="$t('Longitude')"
            :value="Longitude"
            :disabled="region === null"
            @change="handleLongitudeChange" />
        <!-- Chooseing of weather file -->
        <!-- file upload system activation -->
        <form @submit.prevent="sendFile" enctype="multipart/form-data">
        <div class="field">
        <label for="file" class="label">Upload File</label>
        <input type="file"
        ref="file"
        @change="selectFile"
        />
        </div>
        <div class="field">
          <button class="button is-info">send</button>
          </div>
        </form>
        <n-input-select
          :label="$t('soil-type')"
          :options="soils"
          :value="soilId"
          :disabled="region === null"
          @change="handleSoilChange" />
        <!-- Advanced settings -->
        <div class="advanced-settings" v-if="isAdvancedLocationSelected">
          <n-input-number
            :label="$t('soil-layers')"
            min="1"
            max="10"
            :value="soilLayers"
            :disabled="region === null || soil === null"
            @change="handleSoilLayersChange" />
          <div class="initial-n">
            <n-input-number
              v-for="({ label, amount }, index) in soilInitialN"
              :key="index"
              :id="'initial-n-' + (index+1)"
              :type="!index ? '' : 'nolabel'"
              :label="!index ? $t('initial-mineral-n') : ''"
              min="0"
              :value="amount"
              unit="Kg N/ha"
              :footnote="label"
              :disabled="region === null || soil === null"
              @change="setSoilInitialN({ index, value: $event.target.valueAsNumber })"/>
          </div>
        </div>
        <a class="button--advanced-settings" @click="handleAdvancedLocationClick">
          {{ isAdvancedLocationSelected ? $t('ui.hide-advanced-settings') : $t('ui.show-advanced-settings') }}
        </a>
      </section>
      <section>
        <!-- /Advanced settings -->
        <h3>{{$t('crop')}}</h3>
        <n-input-select
          :label="$t('crop-type')"
          :options="crops"
          :value="cropId"
          :disabled="region === null"
          @change="handleCropChange" />
        <n-input-number
            :label="$t('Expected Yield')"
            :value="MainYield"
            unit="ton/ha"
            :disabled="region === null || soil === null || crop === null"
            @change="handleMainYieldChange" />
        <div class="date-group">
          <legend>{{$t('crop-timeline')}}</legend>
          <n-input-date
            class="input"
            :label="$t('sowing-transplanting')"
            :value="cropSeedingDate"
            :disabled="crop === null"
            @change="handleCropSeedingDateChange" />
          <n-input-date
            class="input"
            :label="$t('harvest')"
            :value="cropHarvestDate"
            :disabled="crop === null"
            @change="handleCropHarvestDateChange" />
        </div>
        <!-- Advanced settings -->
        <div class="advanced-settings" v-if="isAdvancedCropSelected">
          <div class="date-group">
            <legend>{{$t('simulation')}}</legend>
            <n-input-date
              class="input"
              :label="$t('start')"
              :value="simulationStartDate"
              :disabled="crop === null"
              @change="handleSimulationStartDateChange" />
            <n-input-date
              class="input"
              :label="$t('end')"
              :value="simulationEndDate"
              :disabled="crop === null"
              @change="handleSimulationEndDateChange" />
          </div>
          <!-- /dactivate the initial bbch
          <div class="date-group">
            <n-input-number
              class="input"
              :label="$t('initial-bbch')"
              :value="cropInitialBBCH"
              :disabled="crop === null"
              @change="handleCropInitialBBCHChange"/>
          </div>
          -->

        </div>
        <!-- /Advanced settings -->
        <a class="button--advanced-settings" @click="handleAdvancedCropClick">
          {{ isAdvancedCropSelected ? $t('ui.hide-advanced-settings') : $t('ui.show-advanced-settings') }}
        </a>
      </section>
    </div>
    <div class="form" v-else-if="isFertilizerManagementSelected">
      <section>
        <h3>{{$t('ui.fertilization-parameters')}}</h3>
        <div class="radio-group">
          <legend>{{$t('volatilization')}}</legend>
          <n-input-radio
            :label="$t('unknown')"
            group="volatilization"
            value="unknown"
            :checked="volatilization === 'unknown'"
            @change="handleVolatilizationChange" />
          <n-input-radio
            :label="$t('low')"
            group="volatilization"
            value="low"
            :checked="volatilization === 'low'"
            @change="handleVolatilizationChange" />
          <n-input-radio
            :label="$t('medium')"
            group="volatilization"
            value="medium"
            :checked="volatilization === 'medium'"
            @change="handleVolatilizationChange" />
          <n-input-radio
            :label="$t('high')"
            group="volatilization"
            value="high"
            :checked="volatilization === 'high'"
            @change="handleVolatilizationChange" />
        </div>
      </section>
      <section>
        <h3>{{$t('ui.organic-application')}}</h3>
        <n-organic-fertilizer-application
          v-for="application in organicApplications"
          :key="application.id"
          :application="application"
          :fertilizers="organicFertilizers"
          @change="handleUpdateOrganicApplication($event)"
        />
      </section>
      <section>
        <h3>{{$t('ui.fertilizer-applications')}}</h3>
        <!-- Fertilizer application -->
        <n-input-switch
          :label="$t('fertigation')"
          :checked="fertigation"
          @change="handleFertigationChange" />
        <n-fertilizer-application
          v-for="(application, index) in applications"
          :key="application.id"
          :application="application"
          :fertilizers="fertilizers"
          :fertigation="fertigation"
          @change="handleUpdateApplication(index, $event)"
          @remove="handleRemoveApplication(index)"
        />
        <button class="button--add-application" type="button" @click="handleAddApplicationClick">
          {{$t('ui.add-application')}}
        </button>
      </section>
    </div>
    <div class="form" v-else-if="isIrrigationManagementSelected">
      <section>
        <h3>{{$t('ui.test_irrigation-applications')}}</h3>
      </section>
      <section>
      <h3>{{$t('ui.irrigation-applications')}}</h3>
      <!-- irrigation application -->
      <n-irrigation-application
        v-for="(application, index) in irrigationApplication"
        :key="application.id"
        :application="application"
        :irrigation_methods="irrigation_methods"
        @change="handleUpdateIrrigationApplication(index, $event)"
        @remove="handleRemoveIrrigationApplication(index)"
      />
      <button class="button--add-application" type="button" @click="handleAddIrrigationApplicationClick">
        {{$t('ui.add-application')}}
      </button>
      </section>
    </div>

  </div>
</template>

<style lang="scss" scoped>

section:not(:last-child) {
  margin-bottom: $spacing--xl;
}

.form {
  @extend %centered-column;
  padding-top: $spacing--xl;
  padding-bottom: $spacing--xl;
}

.data-input-header {
  position: sticky;
  z-index: 1;
  top: $spacing--xl;
  background-color: var(--background--primary);
  box-shadow: 0 1px 0 0 var(--color--outlines),
              0 2rem 2rem var(--background--primary);
  padding-top: $spacing--m;
}

.initial-n {
  display: grid;
  grid-gap: $spacing--xs;
  grid-template-columns: 16rem 6rem 6rem;
  margin-bottom: $spacing--m;
}

.data-input-header__wrapper {
  @extend %centered-column;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}

.button--submit {
  background-color: var(--color--action);
  color: var(--color--white);
}

.date-group,
.radio-group {
  @extend %form-row;
  display: flex;
  align-items: flex-end;
}

.date-group {
  .input {
    width: 10rem;
    margin-right: $spacing--xs;
  }
}

.button--advanced-settings {
  cursor: pointer;
  color: var(--color--action);
  text-decoration: underline;
}

.button--add-application {
  border: 2px solid var(--color--secondary);
  background-color: transparent;
  color: var(--color--primary);
}

</style>

<script>
import axios from 'axios'
import { mapState, mapMutations, mapActions } from 'vuex'
import moment from 'moment'

import Header from '@/components/Header'

import InputSelect from '@/components/InputSelect'
import InputDate from '@/components/InputDate'
import InputNumber from '@/components/InputNumber'
import InputRadio from '@/components/InputRadio'
import InputSwitch from '@/components/InputSwitch'

import FertilizerApplication from '@/components/FertilizerApplication'
import IrrigationApplication from '@/components/IrrigationApplication'
import OrganicFertilizerApplication from '@/components/OrganicFertilizerApplication'

import { Tab } from '@/store/constants'
import { Distribution } from '@/store/modules/constants'

import datalist from '@/helpers/datalist'
import { last } from '@/helpers/array'
import { hasEditor } from '@/helpers/env'

function getRunSimulation () {
  if (hasEditor) {
    return 'simulation/test'
  }
  return 'simulation/retrieveAndRun'
}

export default {
  name: 'input-view',
  data () {
    return {
      file: ''
    }
  },
  components: {
    'n-header': Header,
    'n-input-select': InputSelect,
    'n-input-date': InputDate,
    'n-input-number': InputNumber,
    'n-input-radio': InputRadio,
    'n-input-switch': InputSwitch,
    'n-fertilizer-application': FertilizerApplication,
    'n-organic-fertilizer-application': OrganicFertilizerApplication,
    'n-irrigation-application': IrrigationApplication
  },
  created () {
    // Loads soil data, regions and fertilizers.
    this.loadTypes()
  },
  computed: {
    ...mapState({
      region: (state) => state.region.type,
      regionId: (state) => state.region.type && state.region.type.id,
      regionName: (state) => state.region.type && state.region.type.name,
      regions: (state) => state.region.types.map(datalist.mapOption),
      Latitude: (state) => state.region.latitude,
      Longitude: (state) => state.region.longitude,
      crops: (state) => state.crop.types.map(datalist.mapTranslatedOption(['crops'])),
      crop: (state) => state.crop.type,
      cropId: (state) => state.crop.type && state.crop.type.id,
      cropName: (state) => state.crop.type && state.crop.type.name,
      MainYield: (state) => state.crop.MainYield,
      cropSeedingDate: (state) => moment(state.crop.seedingDate).format('YYYY-MM-DD'),
      cropHarvestDate: (state) => moment(state.crop.harvestDate).format('YYYY-MM-DD'),
      cropInitialBBCH: (state) => state.crop.bbch,
      isAdvancedLocationSelected: (state) => state.isAdvancedLocationSelected,
      isAdvancedCropSelected: (state) => state.isAdvancedCropSelected,
      soils: (state) => state.soil.types.map(datalist.mapTranslatedOption(['soils'])),
      soil: (state) => state.soil.type,
      soilId: (state) => state.soil.type && state.soil.type.id,
      soilName: (state) => state.soil.type && state.soil.type.name,
      soilLayers: (state) => state.soil.layers,
      soilInitialN: (state) => state.soil.initialN,
      volatilization: (state) => state.fertilizer.volatilization,
      fertigation: (state) => state.fertilizer.fertigation,
      irri_fertigation: (state) => state.irrigation.fertigation,
      fertilizers: (state) => state.fertilizer.types.map(datalist.mapOption),
      irrigation_methods: (state) => state.irrigation.types.map(datalist.mapOption),
      applications: (state) => state.fertilizer.applications,
      irrigationApplication: (state) => state.irrigation.applications,
      organicFertilizers: (state) => state.fertilizer.organicTypes.map(datalist.mapTranslatedOption(['organic-fertilizers'])),
      organicApplications: (state) => state.fertilizer.organicApplications,
      simulationStartDate: (state) => moment(state.simulation.startDate).format('YYYY-MM-DD'),
      simulationEndDate: (state) => moment(state.simulation.endDate).format('YYYY-MM-DD'),
      isCropAndSoilSelected: (state) => state.tab === Tab.CROP_SOIL,
      isFertilizerManagementSelected: (state) => state.tab === Tab.FERTILIZER_MANAGEMENT,
      isIrrigationManagementSelected: (state) => state.tab === Tab.IRRIGATION_MANAGEMENT
    })
  },
  methods: {
    ...mapMutations({
      tabChange: 'tabChange',
      setCropInitialBBCH: 'crop/setInitialBBCH',
      setVolatilization: 'fertilizer/setVolatilization',
      setFertigation: 'fertilizer/setFertigation',
      setCropType: 'crop/setType',
      setMainYield: 'crop/setMainYield',
      setSoilType: 'soil/setType',
      setSoilInitialN: 'soil/setInitialN',
      setSoilLayers: 'soil/setLayers',
      setLatitude: 'region/setLatitude',
      setLongitude: 'region/setLongitude',
      addApplication: 'fertilizer/addApplication',
      updateApplication: 'fertilizer/updateApplication',
      removeApplication: 'fertilizer/removeApplication',
      addIrrigationApplication: 'irrigation/addApplication',
      updateIrrigationApplication: 'irrigation/updateApplication',
      removeIrrigationApplication: 'irrigation/removeApplication',
      updateOrganicApplication: 'fertilizer/updateOrganicApplication',
      toggleAdvancedLocationSettings: 'toggleAdvancedLocationSettings',
      toggleAdvancedCropSettings: 'toggleAdvancedCropSettings'
    }),
    ...mapActions({
      setSeedingDate: 'setSeedingDate',
      setHarvestDate: 'setHarvestDate',
      setSimulationStartDate: 'setSimulationStartDate',
      setSimulationEndDate: 'setSimulationEndDate',
      initCropType: 'setCropType',
      loadTypes: 'loadTypes',
      setRegion: 'setRegion',
      runSimulation: getRunSimulation()
    }),
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async sendFile () {
      const formData = new FormData()
      formData.append('file', this.file)
      try {
        await axios.post('/updata', formData)
      } catch (err) {
        console.log(err)
      }
    },
    handleCropChange (e) {
      this.initCropType(e.target.value)
    },
    handleMainYieldChange (e) {
      this.setMainYield(e.target.valueAsNumber)
    },
    handleCropSeedingDateChange (e) {
      this.setSeedingDate(e.target.valueAsDate)
    },
    handleCropHarvestDateChange (e) {
      this.setHarvestDate(e.target.valueAsDate)
    },
    handleCropInitialBBCHChange (e) {
      this.setCropInitialBBCH(e.target.valueAsNumber)
    },
    handleSimulationStartDateChange (e) {
      this.setSimulationStartDate(e.target.valueAsDate)
    },
    handleSimulationEndDateChange (e) {
      this.setSimulationEndDate(e.target.valueAsDate)
    },
    handleSoilChange (e) {
      this.setSoilType(e.target.value)
    },
    handleLatitudeChange (e) {
      this.setLatitude(e.target.valueAsNumber)
    },
    handleLongitudeChange (e) {
      this.setLongitude(e.target.valueAsNumber)
    },
    handleSoilLayersChange (e) {
      this.setSoilLayers(e.target.valueAsNumber)
    },
    handleVolatilizationChange (e) {
      this.setVolatilization(e.target.value)
    },
    handleRegionChange (e) {
      this.setRegion(e.target.value)
    },
    handleFertigationChange (e) {
      this.setFertigation(e.target.checked)
    },
    handleTabCropSoilClick (e) {
      this.tabChange(Tab.CROP_SOIL)
    },
    handleTabFertilizerClick (e) {
      this.tabChange(Tab.FERTILIZER_MANAGEMENT)
    },
    handleTabIrrigationClick (e) {
      this.tabChange(Tab.IRRIGATION_MANAGEMENT)
    },

    handleAddIrrigationApplicationClick (e) {
      const newApplication = {
        fertilizer: '4',
        rate: 20,
        date: moment(this.cropSeedingDate).toDate(),
        fromDate: moment(this.cropSeedingDate).toDate(),
        toDate: moment(this.cropHarvestDate).toDate(),
        every: 1,
        distribution: this.irri_fertigation
          ? Distribution.PERIODICAL
          : Distribution.ONE_TIME
      }
      if (this.applications.length > 0) {
        const lastApplication = last(this.applications)
        newApplication.date = moment(lastApplication.date).add(1, 'd').toDate()
        newApplication.fromDate = moment(lastApplication.toDate).add(1, 'd').toDate()
        newApplication.toDate = moment(this.cropHarvestDate).toDate()
      }
      this.addIrrigationApplication(newApplication)
    },
    handleUpdateIrrigationApplication (index, e) {
      const { name, value } = e
      const data = { index, [name]: value }
      this.updateIrrigationApplication(data)
    },
    handleRemoveIrrigationApplication (index) {
      this.removeIrrigationApplication(index)
    },

    handleAddApplicationClick (e) {
      const newApplication = {
        fertilizer: '4',
        rate: 0,
        bbch: 0,
        date: moment(this.cropSeedingDate).toDate(),
        fromDate: moment(this.cropSeedingDate).toDate(),
        toDate: moment(this.cropHarvestDate).toDate(),
        every: 1,
        distribution: Distribution.ONE_TIME
      }
      if (this.applications.length > 0) {
        const lastApplication = last(this.applications)
        newApplication.date = moment(lastApplication.date).add(1, 'd').toDate()
        newApplication.fromDate = moment(lastApplication.toDate).add(1, 'd').toDate()
        newApplication.toDate = moment(this.cropHarvestDate).toDate()
      }
      this.addApplication(newApplication)
    },
    handleUpdateApplication (index, e) {
      const { name, value } = e
      const data = { index, [name]: value }
      this.updateApplication(data)
    },
    handleRemoveApplication (index) {
      this.removeApplication(index)
    },
    handleUpdateOrganicApplication (e) {
      const { name, value } = e
      const data = { index: 0, [name]: value }
      this.updateOrganicApplication(data)
    },
    async handleRunSimulationClick (e) {
      await this.runSimulation()
      if (hasEditor) {
        this.$router.push('/editor')
      } else {
        this.$router.push('/output')
      }
    },
    handleAdvancedLocationClick (e) {
      this.toggleAdvancedLocationSettings()
    },
    handleAdvancedCropClick (e) {
      this.toggleAdvancedCropSettings()
    }
  }
}
</script>
